import React from 'react';
import './App.css';
import Timer from './Timer/Timer';

const App = () => {
  return (
    <div className='App'>
      <Timer seconds='0' />
    </div>
  );
}

export default App;
